import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";

replaceInChain(chain, PopulateApiParameter, props => {
    const state = props.getState();
    const location = getLocation(state);
    const currentPage = getCurrentPage(state);
    
    const { onSuccess, onError, isLoadMore, ...parameter } = props.parameter;
    props.apiParameter = parameter;

    if (props.parameter.isLoadMore) {
        const prevApiParams: typeof props.apiParameter = { ...props.apiParameter };
        prevApiParams.page =
            props.apiParameter.page && props.apiParameter.page > 1 ? props.apiParameter.page - 1 : undefined;
        const prevProducts = getProductsDataView(props.getState(), prevApiParams).value;
        if (!prevProducts && props.parameter.page && props.parameter.page > 1) {
            props.apiParameter.page = 1;
            props.apiParameter.pageSize = props.parameter.pageSize! * props.parameter.page;
        }
    }
    const {search} = location;
    const {type} = currentPage;
    if(search.includes("query") && !search.includes("pageSize") && type === "ProductListPage") {
        props.apiParameter.pageSize = 10;
    }

});
